import React from 'react';
type SectionProps = {
  index: string;
  label: string;
  title: string;
  intro?: string;
  price?: string;
  duration?: string;
  children: React.ReactNode;
};
export function Section({
  index,
  label,
  title,
  intro,
  price,
  duration,
  children
}: SectionProps) {
  return <section className="border-b border-line" data-id="element-100" data-mp="gv2hvldm6lh2">
      <div className="mx-auto max-w-5xl px-8 py-14 md:px-12 md:py-16" data-id="element-101" data-mp="gwdlnl727t86">
        <div className="flex flex-wrap items-start justify-between gap-6" data-id="element-102" data-mp="1dlbgt4iq1t5v">
          <div className="max-w-2xl" data-id="element-103" data-mp="18m8n2g86z9d7">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent" data-id="element-104" data-mp="18n9ywmx17zvz">
              {index} — {label}
            </p>
            <h2 className="mt-4 text-2xl font-semibold tracking-tight text-white md:text-4xl" data-id="element-105" data-mp="13t5tw97bu1xj">
              {title}
            </h2>
            {intro && <p className="mt-4 text-[15px] leading-relaxed text-white/55" data-id="element-106" data-mp="1wcl0g6m7hyb6">
                {intro}
              </p>}
          </div>

          {price && <div className="rounded-xl border border-line bg-surface px-5 py-4 text-right" data-id="element-107" data-mp="29kjme5ski31i">
              <p className="whitespace-nowrap text-2xl font-semibold tracking-tight text-white md:text-3xl" data-id="element-108" data-mp="2ejwizi98qoha">
                {price}
              </p>
              {duration && <p className="mt-1 text-[11px] uppercase tracking-[0.14em] text-white/40" data-id="element-109" data-mp="1ztffzugyjqia">
                  {duration}
                </p>}
            </div>}
        </div>

        <div className="mt-10" data-id="element-110" data-mp="1qwy58sci9un2">{children}</div>
      </div>
    </section>;
}